import IntegrationTaskResourceListResultModel from '../../generated/types/model/resource/IntegrationTaskResourceListResultModel';

export default class IntegrationTaskResourceListResultViewModel extends IntegrationTaskResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
